import { useAddNativeClasses } from '@carvana/merch-native/hooks';
import { useTrackClickEvents } from '@carvana/merch-react-hooks';
import { legacySizes } from '~/constants/common/resizeBreakpoints';
import { useNativeDeviceType } from '~/context/common/DeviceContext';
import { useIsLoggedIn } from '~/context/common/UserContext';
import { useTrackEvent } from '~/context/srp/SearchAnalyticsContext';
import useGetFavorites from '~/hooks/common/favorites/useGetFavorites';
import useDataDogRUM from '~/hooks/common/useDataDogRUM';
import useGetCommonTrades from '~/hooks/common/useGetTrades';
import useResizeListener from '~/hooks/common/useResizeListener';
import useSynchronizeAuth from '~/hooks/common/useSynchronizeAuth';
import { useGetLowInventoryAvailability } from '~/hooks/srp/services/useGetAvailability';
import useGetAvailability from '~/hooks/srp/services/useGetAvailability';
import useGetInventory, {
  useGetFacetData
} from '~/hooks/srp/services/useGetInventory';
import useGetPricing from '~/hooks/srp/services/useGetPricing';
import useGetSavedSearches from '~/hooks/srp/services/useGetSavedSearches';
import useEnsureFinanceFiltersAreInRange from '~/hooks/srp/useEnsureFinanceFiltersAreInRange';
import useEnsureValidSortBy from '~/hooks/srp/useEnsureValidSortBy';
import useModalScrollRestoration from '~/hooks/srp/useModalScrollRestoration';
import useSetDataDogContext from '~/hooks/srp/useSetDataDogContext';
import useTrackTilePerformance from '~/hooks/srp/useTrackTilePerformance';
import useTradeToggled from '~/hooks/srp/useTradeToggled';
import {
  useNativeMessageDispatcher,
  useNativeMessageListener
} from '~/native/srp';
import {
  useGetCreditStatus,
  useLogZipCodeChanges,
  useMerchWindowObject,
  useNavigation,
  useRegenerateSearchSessionId,
  useRemoveQueryParams,
  useScrollToTop,
  useSetCvnaId,
  useSetPageNumber,
  useShowFinance,
  useShowManageSavedSearchesOnLoad,
  useToggleAppliedTradeCookie
} from './hooks';
import { useFilteredByMinDown } from './hooks/conditionalTiles';
import { useTrackResults } from './hooks/events';

type OwnProps = {
  fetchedInventoryOnServer?: boolean;
};

export default function SearchData(props: OwnProps) {
  const isLoggedIn = useIsLoggedIn();
  const nativeDeviceType = useNativeDeviceType();
  const trackEvent = useTrackEvent();

  useDataDogRUM();
  useSynchronizeAuth();
  useRemoveQueryParams();
  useShowManageSavedSearchesOnLoad();
  useGetCreditStatus();
  useGetCommonTrades(isLoggedIn);
  useTradeToggled();
  useResizeListener(legacySizes);
  useTrackTilePerformance();
  useGetFavorites();
  useGetFacetData();
  useGetInventory(props.fetchedInventoryOnServer);
  useGetAvailability();
  useGetPricing();
  useGetSavedSearches();
  useNavigation();
  useScrollToTop();
  useSetCvnaId();
  useSetPageNumber();
  useShowFinance();
  useToggleAppliedTradeCookie();
  useTrackClickEvents(trackEvent);
  useTrackResults();
  useSetDataDogContext();
  useGetLowInventoryAvailability();
  useLogZipCodeChanges();
  useFilteredByMinDown();
  useNativeMessageDispatcher();
  useNativeMessageListener();
  useAddNativeClasses(nativeDeviceType.isNative, nativeDeviceType.platform);
  useModalScrollRestoration();
  useMerchWindowObject();
  useRegenerateSearchSessionId();
  useEnsureFinanceFiltersAreInRange();
  useEnsureValidSortBy();

  return null;
}
